import { objectService } from "@/api/services/object.service";
import * as Sentry from "@sentry/tanstackstart-react";
import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { authMiddlewareServer } from "../middleware/auth";

export const listMediaFn = createServerFn({ method: "GET" })
  .middleware([authMiddlewareServer])
  .handler(async ({ context }) => {
    return await Sentry.startSpan(
      { name: "action.listMediaFn", op: "function" },
      async () => {
        if (context.auth.role !== "admin") {
          return {
            status: 403,
            body: { message: "Forbidden" },
          };
        }

        const objects = await Sentry.startSpan(
          { name: "objectService.listObjects", op: "db" },
          () => objectService.listObjects(""),
        );
        const totalSize = objects.reduce(
          (sum, obj) => sum + (obj.size || 0),
          0,
        );

        return {
          status: 200,
          body: {
            objects,
            total: objects.length,
            totalSize,
          },
        };
      },
    );
  });

export const listMediaOptions = () =>
  queryOptions({
    queryKey: ["listMedia"],
    queryFn: () => listMediaFn(),
    staleTime: 0, // Always fetch fresh data (prevents cache issues)
  });

export const listPublicMediaFn = createServerFn({ method: "GET" }).handler(
  async () => {
    return await Sentry.startSpan(
      { name: "action.listPublicMediaFn", op: "function" },
      async () => {
        const objects = await Sentry.startSpan(
          { name: "objectService.listObjects", op: "db" },
          () => objectService.listObjects(""),
        );

        // Filter only image types
        const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp"];
        const images = objects.filter((obj) =>
          imageExtensions.includes(obj.extension.toLowerCase()),
        );

        return {
          status: 200,
          body: {
            objects: images,
            total: images.length,
          },
        };
      },
    );
  },
);

export const listPublicMediaOptions = () =>
  queryOptions({
    queryKey: ["listPublicMedia"],
    queryFn: () => listPublicMediaFn(),
  });
